'use strict';

var jsxRuntime = require('react/jsx-runtime');
var Link = require('next/link');
require('../../DataDisplays/Avatar/Avatar.js');
require('tailwind-merge');
var Typography = require('../../Base/Typography/Typography.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
require('../../DataDisplays/Label/Label.js');
var SystemIcon = require('../../DataDisplays/SystemIcon/SystemIcon.js');

const ExternalLinks = ({ links })=>{
    return jsxRuntime.jsx(Box, {
        className: "flex h-auto w-full flex-col gap-3 p-6",
        "data-testid": "design-system-message-box--external-links-container",
        children: links === null || links === void 0 ? void 0 : links.map((item, index)=>jsxRuntime.jsxs(Link, {
                target: item.target || '_blank',
                prefetch: item.target === '_self',
                href: item.url,
                className: "flex items-center justify-between text-w-gray-600 no-underline",
                "data-testid": `design-system-message-box--external-links-item-${index}`,
                children: [
                    jsxRuntime.jsx(Typography, {
                        variant: "body1",
                        className: "hover:underline hover:underline-offset-2",
                        children: item.title
                    }),
                    jsxRuntime.jsx(SystemIcon, {
                        name: "small_arrow_right"
                    })
                ]
            }, `${item.title}-${item.url}`))
    });
};

exports.ExternalLinks = ExternalLinks;
